import React from "react";

const faq1 = () =>{
  return(
    <>
      <p>
        I <i>din</i>BiZ identifierar du snabbt dina nycklar 
        till ökad lönsamheten – från helhet till 
        minsta detalj. Du kan fritt simulera 
        tänkbara lönsamhetslösningar och enkelt 
        läsa av resultatet som månadslön efter 
        skatter & avgifter (schablon) – i realtid. 
      </p>
      <p>
        Ett effektivt instrument för metodiskt ökad 
        lönsamhet som hjälper dig fokusera på det 
        som gäller, enligt formeln
      </p>
      <p className="ms-4">
        <i> Intäkter – Kostnader = Lönsamhet </i>
      </p>
      <p>
        Det finns ingen slutlig lösning för att nå max
        möjliga lönsamhet eftersom allt förändras 
        över tid – ibland mycket kort tid. Därför kör 
        du <i>din</i>BiZ löpande eller så ofta du behöver.
      </p>
      <p>
        Se Flik: <u>Vad är lönsamhet?</u>
      </p>
    
    </>
  );
}
export default faq1;